/**
 * 应用中心门店模块
 */
export const ApplyStoreManageArr = [
  {
    path: "merchants/:id(\\d+)",
    name: "merchants",
    meta: {
      title: "多商户"
    },
    redirect: "/apply/merchants/:id(\\d+)/shopsManage",
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "shopsManage",
        name: "shopsManage",
        meta: {
          title: "商户管理"
        },
        component: () =>
          import("@/views/apply/comModule/mall/shops/shopsManage.vue")
      },
      {
        path: "shopsSetting",
        name: "shopsSetting",
        meta: {
          title: "店铺设置"
        },
        component: () =>
          import("@/views/apply/comModule/mall/shops/shopsSetting.vue")
      },
      {
        path: "shopsCommodity",
        name: "shopsCommodity",
        meta: {
          title: "商户商品"
        },
        component: () =>
          import("@/views/apply/comModule/mall/shops/shopsCommodity.vue")
      },
      {
        path: "shopsOrder",
        name: "shopsOrder",
        meta: {
          title: "商户订单"
        },
        component: () =>
          import("@/views/apply/comModule/mall/shops/shopsOrder.vue")
      },
      {
        path: "shopsAccount",
        name: "shopsAccount",
        meta: {
          title: "商户结算"
        },
        component: () =>
          import("@/views/apply/comModule/mall/shops/shopsAccount.vue")
      },
      {
        path: "shopsServe",
        name: "shopsServe",
        meta: {
          title: "商户服务"
        },
        component: () =>
          import("@/views/apply/comModule/mall/shops/shopsServe.vue")
      },
      //多商户内的表单
      {
        path: "addMerchant",
        name: "addMerchant",
        meta: {
          title: "添加商户"
        },
        component: () =>
          import("@/views/apply/comModule/mall/shops/forms/addMerchant")
      },
      {
        path: "shopClassForm",
        name: "shopClassForm",
        meta: {
          title: "商户分类"
        },
        component: () =>
          import("@/views/apply/comModule/mall/shops/forms/shopClassForm")
      },
      {
        path: "shopGroupForm",
        name: "shopGroupForm",
        meta: {
          title: "商户分组"
        },
        component: () =>
          import("@/views/apply/comModule/mall/shops/forms/shopGroupForm")
      },
      {
        path: "shopLevelForm",
        name: "shopLevelForm",
        meta: {
          title: "商户等级"
        },
        component: () =>
          import("@/views/apply/comModule/mall/shops/forms/shopLevelForm")
      }
    ]
  }
];
